import { LocDef, LocDefs, LocMap } from '@cm/core/localization';
import { HubFeature } from '@ats/api/cm';

const pathStart = 'Settings|Token Count|';
const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	htmlAllowed: false,
	feature: HubFeature.Benefit,
	portal: 'SP',
};

type LocNameStart = 'SPSettingsTokenCount';
export type SPSettingsTokenCountLocNames =
	| `${LocNameStart}Title`
	| `${LocNameStart}LabelToken`
	| `${LocNameStart}LabelCount`;

export const spSettingsTokenCountLocs: LocDefs<SPSettingsTokenCountLocNames> = {
	SPSettingsTokenCountTitle: {
		defaultValue: 'Token Counts',
		description: 'Title.',
		displayPath: `${pathStart}Title`,
		displayType: 'Title',
		legacyName: 'Benefit/Settings.BenefitTokenCount.Title.Tab',
		...sharedProperties,
	},
	SPSettingsTokenCountLabelToken: {
		defaultValue: 'Token',
		description: 'Column heading for: Token.',
		displayPath: `${pathStart}Token`,
		displayType: 'Label',
		legacyName: 'Benefit/Settings.BenefitTokenCount.ColumnHeading.Token',
		...sharedProperties,
	},
	SPSettingsTokenCountLabelCount: {
		defaultValue: 'Count',
		description: 'Column heading for: Count.',
		displayPath: `${pathStart}Count`,
		displayType: 'Label',
		legacyName: 'Benefit/Settings.BenefitTokenCount.ColumnHeading.RemainingCount',
		...sharedProperties,
	},
};

export type SPSettingsTokenCountLocType = LocMap<SPSettingsTokenCountLocNames>;
